import * as z from "zod";

export const AmAssistantAccountManagerSchema = z.object({
  /** Stringified bigint id of the row in am_assistant_account_manager. */
  id: z.string(),
  email: z.string(),
  aliases: z.array(z.string()),
  enabled: z.boolean(),
  addedBy: z.string(),
  createdAt: z.date(),
});

export type AmAssistantAccountManager = z.infer<
  typeof AmAssistantAccountManagerSchema
>;

/** A rejected write reports `error`; nothing was changed. */
const amAssistantWriteOutput = z.object({ error: z.string().nullable() });

export const listAmAssistantAccountManagers = {
  name: "listAmAssistantAccountManagers" as const,
  input: z.object({}),
  output: z.object({
    accountManagers: z.array(AmAssistantAccountManagerSchema),
  }),
};

export const createAmAssistantAccountManager = {
  name: "createAmAssistantAccountManager" as const,
  input: z.object({ email: z.string(), aliases: z.array(z.string()) }),
  output: amAssistantWriteOutput,
};

export const updateAmAssistantAccountManager = {
  name: "updateAmAssistantAccountManager" as const,
  input: z.object({
    id: z.string(),
    aliases: z.array(z.string()).optional(),
    enabled: z.boolean().optional(),
  }),
  output: amAssistantWriteOutput,
};
